import { deckColumns } from "./-components/deck-columns"
import { UploadDeckDialog } from "./-components/upload-deck-dialog"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { useQuery } from "convex/react"
import { api } from "@convex/_generated/api"
import { DataTable } from "@/components/ui/data-table"
import { Skeleton } from "@/components/ui/skeleton"

const decksSearchSchema = z.object({
  name: z.string().optional().catch(undefined),
})

export const Route = createFileRoute("/(admin)/admin/decks/")({
  component: RouteComponent,
  validateSearch: decksSearchSchema,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { name } = Route.useSearch()
  const decks = useQuery(api.decks.handlers.list)

  const handleNameFilterChange = (value: string) => {
    navigate({
      search: (prev) => ({
        ...prev,
        name: value || undefined,
      }),
    }).catch((error: unknown) => {
      console.error("Navigation error:", error)
    })
  }

  if (!decks) {
    return (
      <div className="flex flex-1 flex-col gap-4 p-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold">Decks</h1>
            <p className="text-sm text-muted-foreground">
              Manage Decks and Upload Anki Decks
            </p>
          </div>
          <UploadDeckDialog />
        </div>
        <div className="space-y-4">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-[400px] w-full" />
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-1 flex-col gap-4 p-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Decks</h1>
          <p className="text-sm text-muted-foreground">
            Manage Decks and Upload Anki Decks
          </p>
        </div>
        <UploadDeckDialog />
      </div>

      <DataTable
        columns={deckColumns}
        data={decks}
        filterColumn="name"
        filterPlaceholder="Filter by deck name..."
        filterValue={name}
        onFilterChange={handleNameFilterChange}
        onRowClick={(deck) => {
          navigate({
            to: "/admin/decks/$deckId",
            params: { deckId: deck._id },
          }).catch((error: unknown) => {
            console.error("Navigation error:", error)
          })
        }}
      />
    </div>
  )
}
